import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StyledTextField from '../common/StyledTextField';
import './PasswordInput.scss';

const uppercaseRegex = /([A-Z]+)/;
const eightCharsRegex = /(^.{8,}$)/;
const oneNumberRegex = /([0-9]+)/;

function ListItem({ completed, children }) {
  return (
    <li className={`${completed ? 'completed-item' : 'uncompleted-item'} body-text-3`}>
      { children }
    </li>
  );
}

ListItem.propTypes = {
  completed: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

function FormItem({ withError, children }) {
  if (!withError) {
    return children;
  }

  return (
    <div className="field_with_errors">
      { children }
    </div>
  );
}

FormItem.propTypes = {
  withError: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

class PasswordInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validUpper: true,
      validEightChars: true,
      validOneNumber: true,
      showPassword: false,
    };

    this.validatePassword = this.validatePassword.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
  }

  validatePassword(event) {
    const { handleChange } = this.props;
    const input = event.target.value;

    this.setState({
      validUpper: uppercaseRegex.test(input),
      validEightChars: eightCharsRegex.test(input),
      validOneNumber: oneNumberRegex.test(input),
    }, handleChange(event));
  }

  toggleShow(e) {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword,
    });
  }

  render() {
    const {
      validUpper, validEightChars, validOneNumber, showPassword,
    } = this.state;
    const {
      errors, autoFocus, title, id, type, tabIndex,
    } = this.props;

    return (
      <div id="password-input">
        <FormItem withError={errors}>
          <StyledTextField
            id={id}
            className="form-control"
            name="user[password]"
            label={title}
            type={!showPassword ? 'password' : 'text'}
            onChange={this.validatePassword}
            tabIndex={tabIndex}
            autoFocus={autoFocus}
            error={errors}
          />
        </FormItem>

        <div className={`g-row ${type === 'new' && !(validUpper && validEightChars && validOneNumber) ? 'g-flex-justify-space-between' : 'g-row-justify-right'}`}>
          <a
            href="toggleShow"
            className="show-hide-btn body-text-3 normal-weight mb-2 text-decoration-none"
            onClick={this.toggleShow}
          >
            { showPassword ? 'Hide password' : 'Show password' }
          </a>

          { (type === 'new')
            && [!(validUpper && validEightChars && validOneNumber)
              ? (
                <ul className="validations-list" key="0">
                  <ListItem completed={validUpper}> One uppercase </ListItem>
                  <ListItem completed={validEightChars}> 8 characters minimum </ListItem>
                  <ListItem completed={validOneNumber}> One number </ListItem>
                </ul>
              )
              : null,
            ]}
        </div>
      </div>
    );
  }
}

PasswordInput.propTypes = {
  errors: PropTypes.bool.isRequired,
  autoFocus: PropTypes.bool,
  title: PropTypes.string.isRequired,
  id: PropTypes.string,
  type: PropTypes.string,
  tabIndex: PropTypes.string,
  handleChange: PropTypes.func,
};

PasswordInput.defaultProps = {
  autoFocus: false,
  id: 'user_password',
  type: 'new',
  tabIndex: null,
  handleChange: () => {},
};

export default PasswordInput;
